import cookie from "react-cookies"


export const aclPermissions = {
	create_user: "create_user",
	delete_user: "delete_user",
	update_user: "update_user",
	view_other_user_permissions: "view_other_user_permissions",
	view_other_user_events: "view_other_user_events",
	create_policy: "create_policy",
	edit_policy: "edit_policy",
	delete_policy: "delete_policy",
	backup_database: "backup_database",
	change_other_users_password: "change_other_users_password",
	download_scans_list: "download_scans_list",
	download_audit_logs: "download_audit_logs",
	clia_staff: "clia_staff",
	update_slides_name: "update_slides_name",
	view_slide_details: "view_slide_details",
	delete_slide: "delete_slide",
	share_slide: "share_slide",
	upload_slide: "upload_slide",
	anonymous_share: "anonymous_share",
	update_slides_in_case: "update_slides_in_case",
	export_slide: "export_slide",
	download_slide_export: "download_slide_export",
	build_stitch_manifest: "build_stitch_manifest",
	create_slide_setting: "create_slide_setting",
	delete_slide_setting: "delete_slide_setting",
	update_slide_setting: "update_slide_setting",
	view_own_annotation: "view_own_annotation",
	view_other_user_annotation: "view_other_user_annotation",
	create_annotation: "create_annotation",
	delete_own_annotation: "delete_own_annotation",
	delete_other_user_annotation: "delete_other_user_annotation",
	update_annotation: "update_annotation",
	create_annotation_comment: "create_annotation_comment",
	view_annotation_comment: "view_annotation_comment",
	annotation_ai: "annotation_ai",
	view_scanner: "view_scanner",
	view_open_gate_now: "view_open_gate_now",
	take_z_scans: "take_z_scans",
	update_specimen_setting: "update_specimen_setting",
	live_mode: "live_mode",
	scan_calibration: "scan_calibration",
	read_barcode_with_preview: "read_barcode_with_preview",
	create_case: "create_case",
	delete_case: "delete_case",
	assign_case: "assign_case",
	export_cases_as_pdf: "export_cases_as_pdf",
	generate_report: "generate_report",
	update_cap_report: "update_cap_report",
	edit_case_details: "edit_case_details",
	view_case_details: "view_case_details",
	view_all_cases: "view_all_cases",
	keyboard_shortcuts_app: "keyboard_shortcuts_app",
	slide_info_app: "slide_info_app",
	tile_view_app: "tile_view_app",
	case_info_app: "case_info_app",
	cap_report_app: "cap_report_app",
	display_settings_app: "display_settings_app",
	grid_overlay_app: "grid_overlay_app",
	screenshot_app: "screenshot_app",
	ai_chat_app: "ai_chat_app",
	deep_bio_app: "deep_bio_app",
	ihc_app: "ihc_app",
	labelling_app: "labelling_app",
	clia_app: "clia_app",
	slide_navigator_app: "slide_navigator_app",
	services_app: "services_app",
	disks_app: "disks_app",
	configuration_app: "configuration_app",
	display_calibration_app: "display_calibration_app",
	preview_controls_app: "preview_controls_app",
	thumbnail_app: "thumbnail_app",
	barcode_app: "barcode_app",
	layers_control_app: "layers_control_app",
	zoom_control_app: "zoom_control_app",
	zStack_control_app: "zStack_control_app",
	exposure_control_app: "exposure_control_app",
	background_blend_app: "background_blend_app",
	blood_annotations_app: "blood_annotations_app",
	split_sync_app: "split_sync_app",
	case_image_app: "case_image_app",
	edit_anno_label_app: "edit_anno_label_app",
	one_to_one_pdf_app: "one_to_one_pdf_app",
	indx_app: "indx_app",
	mets_beta_app: "mets_beta_app",
	share_link: "share_link",
	anno_width_app: "anno_width_app",
	arrow_anno_app: "arrow_anno_app",
	prev_next_slide_app: "prev_next_slide_app",
	use_osd_viewer: "use_osd_viewer",
	configure_viewer_settings: "configure_viewer_settings",
	customize_viewer_sensitivity: "customize_viewer_sensitivity",
	view_seen_area_heatmap: "view_seen_area_heatmap",
	modify_export_settings: "modify_export_settings",
	create_group: "create_group",
	clia_menu: "clia_menu",
	folders_menu: "folders_menu",
	stats_info_menu: "stats_info_menu",
	disk_info_menu: "disk_info_menu",
	general_setting_menu: "general_setting_menu",
	cases_menu: "cases_menu",
	manage_users_menu: "manage_users_menu",
	import_scan_menu: "import_scan_menu",
	devices_menu: "devices_menu",
	update_slides_description: "update_slides_description",
	common_chat_room: "common_chat_room",
}

export const hasPermissions = (permissions) => permissions 
	.filter(p => !(cookie.load('default_access_permissions') || []).includes(p)) 
	.reduce((prev, p) => prev && (cookie.load('access_permissions') || []).includes(p), true)